import { Expr } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

import { ExternalResources } from "../core/types";

import { getExpressionResolver } from "./registry";

export const resolveExpression = async (
  expression: Expr | undefined,
  fieldValueResolver: (name: string) => unknown,
  externalResources?: ExternalResources
): Promise<unknown | undefined> => {
  if (expression === undefined) {
    return undefined;
  }

  if (expression.function) {
    const resolver = getExpressionResolver(expression.function);

    if (resolver) {
      return await resolver({
        expression,
        templateFieldValueResolver: fieldValueResolver,
        externalResources,
      });
    } else {
      console.warn(
        `[FormEngine:resolveExpression] Expression function '${expression.function}' not found in registry`
      );
    }
  }

  if (expression.params) {
    if ("value" in expression.params) {
      return expression.params.value;
    } else if ("ref" in expression.params) {
      const fieldValue = fieldValueResolver(
        typeof expression.params.ref === "string"
          ? expression.params.ref
          : String(expression.params.ref)
      );

      return fieldValue;
    }
  }

  return undefined;
};

export const resolveExpressions = async (
  expressions: Expr[],
  fieldValueResolver: (name: string) => unknown,
  externalResources?: ExternalResources
): Promise<unknown[] | undefined> => {
  if (!expressions || !Array.isArray(expressions) || expressions.length === 0) {
    return undefined;
  }

  const resolvedValues = await Promise.all(
    expressions.map((expr) =>
      resolveExpression(expr, fieldValueResolver, externalResources)
    )
  );

  return resolvedValues.length > 0 ? resolvedValues : undefined;
};
